import React from 'react';
import { Container } from 'reactstrap';
import Link from 'next/link';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Answer, QuestionDetail } from '../categories/types';
import style from './Answers.module.scss';

const AnswerElement: React.FC<{ answer: Answer }> = ({ answer }) => {
  return (
    <div className={classNames('flex-row d-flex align-items-center mx-5', style.box)}>
      <div className={style.text}>{answer.text}</div>
      <div className={style.point}>{answer.points}</div>
    </div>
  );
};

const ButtonElement: React.FC<{ questionDetails: QuestionDetail }> = ({ questionDetails }) => {
  const intl = useIntl();
  const { locale } = useRouter();
  const { slug } = questionDetails.category;
  return (
    <div className={classNames('pt-5 d-flex justify-content-center align-items-center', style.btnAllQuestionsBox)}>
      <Link
        prefetch={false}
        href={`/${locale}/questions/categories/${slug}/`}
        passHref
        className={classNames('text-decoration-none', style.btnAllQuestions)}
      >
        {intl.formatMessage({
          id: 'web.question_details.show_all',
          defaultMessage: 'Show all questions'
        })}
      </Link>
    </div>
  );
};
export const QuestionDetailsList: React.FC<{ questionDetails: QuestionDetail }> = React.memo(({ questionDetails }) => {
  const { answers, text } = questionDetails;
  return (
    <Container className="d-flex flex-column align-items-center justify-content-center mt-5 pb-5">
      <div className={classNames('d-flex flex-column', style.boxAnswer)}>
        <div className={classNames('pb-5 px-5 justify-content-center d-flex', style.answerTitle)}>{text}</div>
        <div className="d-flex flex-column">
          {answers.map((answer) => (
            <AnswerElement key={answer.id} answer={answer} />
          ))}
        </div>
      </div>
      <ButtonElement questionDetails={questionDetails} />
    </Container>
  );
});
